export const ROUTE_HOME = 'home';
export const ROUTE_GAME = 'game';
export const ROUTE_NEW_GAME = 'new-game';
